<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal [customTitle]="(id ? 'Editar' : 'Nueva') + ' medida'" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="space-y-6">
        <div class="grid grid-cols-1 gap-4">

            <custom-input [autofocus]="true" label="Nombre" type="text" [formControlItem]="saveForm.get('name')">
            </custom-input>

            <custom-input label="Descripción abreviada" type="text" [formControlItem]="saveForm.get('short_name')">
            </custom-input>

            <custom-input label="Descripción" type="text" [formControlItem]="saveForm.get('description')">
            </custom-input>

        </div>
    </form>
</app-custom-modal>
}